type DownloadBlobFileOptions = {
  fileName: string;
  onDownloadStart?: () => void;
  onDownloadComplete?: () => void;
  autoRevokeUrl?: boolean;
};

export const downloadBlobFile = async (
  responsePromise: Promise<Response>,
  options: DownloadBlobFileOptions
): Promise<void> => {
  const response = await responsePromise;

  if (!response.ok) {
    throw new Error(`Failed to download file: ${response.statusText}`);
  }

  options.onDownloadStart?.();

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = options.fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();

  if (options.autoRevokeUrl ?? true) {
    URL.revokeObjectURL(url);
  }

  options.onDownloadComplete?.();
};
